import { render, staticRenderFns } from "./Chatbox.vue?vue&type=template&id=06f4bfe6&"
import script from "./Chatbox.vue?vue&type=script&lang=js&"
export * from "./Chatbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports